const PRODUCTS = [
	{
		id: 1,
		name: '2k22 WWE New Editon Video Game',
		price: '$12',
		image: require  ('./images/1.jpg'),
		
		details:
		"The WWE Shop is your online source for all things WWE including title belts, apparel and accessories. Get excited for the upcoming Survivor Series WarGames with newly-released WWE Survivor Series T-Shirts and more." 
	},
	{
		id: 2,
		name: 'The Blood Line Tshirt',
		price: '$14',
		image: require('./images/2.jpg'),
		details:
			'The WWE Shop is your online source for all things WWE including title belts, apparel and accessories. Get excited for the upcoming Survivor Series WarGames with newly-released WWE Survivor Series T-Shirts and more. ',
	},
	{
		id: 3,
		name: 'Becky Lynch Tshirt',
		price: '$13.67',
		image: require('./images/3.jpg'),
		details:
			'The WWE Shop is your online source for all things WWE including title belts, apparel and accessories. Get excited for the upcoming Survivor Series WarGames with newly-released WWE Survivor Series T-Shirts and more. ',
	},
	{
		id: 4,
		name: 'WWE Championship Belt',
		price: '$47.56',
		image: require('./images/4.jpg'),
		details:
			'The WWE Shop is your online source for all things WWE including title belts, apparel and accessories. Get excited for the upcoming Survivor Series WarGames with newly-released WWE Survivor Series T-Shirts and more. ',
	},
	{
		id: 5,
		name: 'WWE United States Championship Belt',
		price: '$53.06',
		image: require('./images/5.jpg'),
		details:
			'The WWE Shop is your online source for all things WWE including title belts, apparel and accessories. Get excited for the upcoming Survivor Series WarGames with newly-released WWE Survivor Series T-Shirts and more. ',
	},
	{
		id: 6,
		name: 'Roman Reigns WWE Accessories',
		price: '$93.20',
		image: require('./images/6.jpg'),
		details:
			'The WWE Shop is your online source for all things WWE including title belts, apparel and accessories. Get excited for the upcoming Survivor Series WarGames with newly-released WWE Survivor Series T-Shirts and more. ',
	},
	{
		id: 7,
		name: 'WWE Hoddies',
		price: '$25',
		image: require('./images/7.jpg'),
		details:
			'The WWE Shop is your online source for all things WWE including title belts, apparel and accessories. Get excited for the upcoming Survivor Series WarGames with newly-released WWE Survivor Series T-Shirts and more. ',
	},
	{
		id: 8,
		name: 'Uncle Howdy TShirt',
		price: '$99.98',
		image: require('./images/8.jpg'),
		details:
			'The WWE Shop is your online source for all things WWE including title belts, apparel and accessories. Get excited for the upcoming Survivor Series WarGames with newly-released WWE Survivor Series T-Shirts and more. ',
	},
	{
		id: 9,
		name: 'Ricochet TShirt',
		price: '$87.22',
		image: require("./images/9.jpg"),
		details:
			'The WWE Shop is your online source for all things WWE including title belts, apparel and accessories. Get excited for the upcoming Survivor Series WarGames with newly-released WWE Survivor Series T-Shirts and more. ',
	},
	{
		id: 10,
		name: 'Logan Paul TShirt',
		price: '$11',
		image: require('./images/10.jpg'),
		details:
			'The WWE Shop is your online source for all things WWE including title belts, apparel and accessories. Get excited for the upcoming Survivor Series WarGames with newly-released WWE Survivor Series T-Shirts and more. ',
	},
	{
		id: 11,
		name: 'WWE products',
		price: '$69',
		image: require('./images/11.jpg'),
		details:
			'The WWE Shop is your online source for all things WWE including title belts, apparel and accessories. Get excited for the upcoming Survivor Series WarGames with newly-released WWE Survivor Series T-Shirts and more. ',
	},
	{
		id: 12,
		name: 'Brother Of Destuction Belt',
		price: '$33',
		image: require('./images/12.jpg'),
		details:
			'The WWE Shop is your online source for all things WWE including title belts, apparel and accessories. Get excited for the upcoming Survivor Series WarGames with newly-released WWE Survivor Series T-Shirts and more. ',
	},
	{
		id: 13,
		name: 'Jhon Cena Sweater',
		price: '$99',
		image: require('./images/13.jpg'),
		details:
			'The WWE Shop is your online source for all things WWE including title belts, apparel and accessories. Get excited for the upcoming Survivor Series WarGames with newly-released WWE Survivor Series T-Shirts and more. ',
	},
	{
		id: 14,
		name: 'Jhon Cena Wrist band',
		price: '$44',
		image: require('./images/14.jpg'),
		details:
			'The WWE Shop is your online source for all things WWE including title belts, apparel and accessories. Get excited for the upcoming Survivor Series WarGames with newly-released WWE Survivor Series T-Shirts and more. ',
	},
	{
		id: 15,
		name: 'Randy Orten Cap',
		price: '$22.22',
		image: require('./images/15.jpg'),
		details:
			'The WWE Shop is your online source for all things WWE including title belts, apparel and accessories. Get excited for the upcoming Survivor Series WarGames with newly-released WWE Survivor Series T-Shirts and more. ',
	},
];

export default PRODUCTS;